<!-- Global Setup Modal -->
<app-global-setup-modal></app-global-setup-modal>

<!-- Loading overlay while checking setup -->
<div *ngIf="isInitializing" class="global-setup-overlay">
    <div class="flex flex-column align-items-center gap-3">
        <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
        <span class="text-white">Initializing application...</span>
    </div>
</div>